import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Terms from "./views/Terms.vue";
import Contact from "./views/Contact.vue";
// import PageNotFound from "./views/PageNotFound.vue";
import Buy from "./views/Buy.vue";
import Debt from "./views/Debt.vue";
import ApproveConsignment from "./views/ApproveConsignment.vue";
import ApprovePurchase from "./views/ApprovePurchase.vue";
import Dashboard from "./views/Dashboard.vue";
import Config from "./views/Config.vue";
import Consignment from "./views/Consignment.vue";
import Forgot from "./views/Forgot.vue";
import Api from "./views/Api.vue";
import Companies from "./views/Companies.vue";
import Users from "./views/Users.vue";
import BalanceBanks from "./views/BalanceBanks.vue";
import Resumen from "./views/Resumen.vue";
import Wallet from "./views/Wallet.vue";
import View2fa from "./views/2fa.vue";

Vue.use(Router);

var r = {
  routes: [
    {
      path: "/",
      name: "home",
      component: Login
    },

    {
      path: "/resumen",
      name: "resumen",
      component: Resumen
    },

    {
      path: "/terms",
      name: "terms",
      component: Terms
    },
    {
      path: "/2fa",
      name: "2fa",
      component: View2fa
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact
    },

    {
      path: "/forgot",
      name: "forgot",
      component: Forgot
    },

    {
      path: "/login",
      name: "login",
      component: Login
    },

    {
      path: "/buy",
      name: "buy",
      component: Buy
    },

    {
      path: "/debt",
      name: "debt",
      component: Debt
    },

    {
      path: "/approveConsignment",
      name: "approveConsignment",
      component: ApproveConsignment
    },

    {
      path: "/companies",
      name: "companies",
      component: Companies
    },

    {
      path: "/approvePurchase",
      name: "approvePurchase",
      component: ApprovePurchase
    },

    {
      path: "/users",
      name: "users",
      component: Users
    },

    {
      path: "/balanceBanks",
      name: "balanceBanks",
      component: BalanceBanks
    },

    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard
    },

    {
      path: "/configs",
      name: "configs",
      component: Config
    },

    {
      path: "/consignment",
      name: "consignment",
      component: Consignment
    },

    {
      path: "/wallet",
      name: "wallet",
      component: Wallet
    },

    {
      path: "/api",
      name: "api",
      component: Api
    }
  ]
};

export default new Router(r);
